export default "__VITE_ASSET__BKa$bZqk__"